module.exports = __webpack_public_path__ + "img/navigating_hybrid_work.390b1b9b.png";